import React from "react";
import "../style/Holiday.css";


const Holiday = () => {
    
  return (
    <div className="Holiday-container">
        <div className="holiday-header">
            <h1>National Holidays Calendar</h1>
        </div>

        <div className="holiday-text">
            <p>The global National Holidays Calendar displays past and
                future dates of the public holidays on which banks in the
                corresponding country are closed.
            </p>
       </div>
     
    
      </div>
       
    );
  };
  
  export default Holiday;